import { Box, styled } from '@ltvco/refresh-lib/theme';

export const ClearAllChip = styled('div')(({ theme }) => ({
  '& .MuiChip-root': {
    height: '28px',
    fontSize: '0.8rem',
    color: theme.palette.text.secondary,
    borderColor: theme.palette.divider,
    flexShrink: 0,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      borderColor: theme.palette.text.secondary,
    },
  },
}));

export const SearchResultChip = styled('div')(({ theme }) => ({
  '& .MuiChip-root': {
    maxWidth: '300px',
    height: '32px',
    backgroundColor: 'transparent',
    borderColor: theme.palette.divider,
    color: theme.palette.text.secondary,
    transition: 'all 0.15s ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
    },
    '&:active': {
      backgroundColor: theme.palette.primary.light,
    },
    '& .MuiChip-label': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: '0.95rem',
      fontWeight: 400,
    },
  },
}));

export const RecentSearchContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(4),
  maxWidth: '600px',
}));

export const RecentSearchHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(1.5),
  gap: theme.spacing(2),
}));

export const RecentSearchChipsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
}));
